import * as React from 'react';
import { ViewpointBuilderFooter } from 'viewpointBuilder/components/ViewpointBuilderFooter';
import { TraversalBuilderViewState } from '../types';
import { PrimaryButtonConfig } from 'viewpointBuilder/openViewpointBuilder/getPrimaryButtonConfig';
import { WithMetamodelLoader } from '../components/WithMetamodelLoader';
import { ResizablePageBody } from '@ardoq/page-layout';
import { SimpleGraphView } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphView';
import { SimpleGraphContainerWithGreyBackground } from 'viewpointBuilder/components/SimpleGraph/SimpleGraphViewContainer';
import { createGraphInterface } from '../components/SimpleGraph/GraphInterface';
import { CollapsePathsSidebar } from './CollapsePathsSidebar';
import { CollapsePathsCommands } from './collapsePathsCommands';
import type { I18nLocale } from '@ardoq/i18n';

type CollapsePathsTabContentProps = {
  state: TraversalBuilderViewState;
  commands: CollapsePathsCommands;
  closeViewpointBuilder: () => void;
  toggleGraphNodeSelection: (
    event: React.MouseEvent<Element, MouseEvent>
  ) => void;
  primaryButtonConfig: PrimaryButtonConfig;
  label: string;
  graphNodeOnHover: (event: React.MouseEvent<Element, MouseEvent>) => void;
  i18nLocale: I18nLocale;
};

export const CollapsePathsTabContent = ({
  state,
  commands,
  closeViewpointBuilder,
  toggleGraphNodeSelection,
  primaryButtonConfig,
  label,
  graphNodeOnHover,
  i18nLocale,
}: CollapsePathsTabContentProps) => {
  const {
    graphNodes,
    graphEdges,
    graphGroups,
    isMetaModelLoaded,
    pathCollapsing: { currentEditableRule },
  } = state;
  const graphInterface = React.useRef(createGraphInterface());
  const isFirstRender = React.useRef(true);
  React.useEffect(() => {
    isFirstRender.current = false;
  }, []);
  return (
    <WithMetamodelLoader
      isMetaModelLoaded={isMetaModelLoaded}
      closeViewpointBuilder={closeViewpointBuilder}
      i18nLocale={i18nLocale}
    >
      <ResizablePageBody
        skipPadding
        footerContent={
          <ViewpointBuilderFooter
            closeViewpointBuilder={closeViewpointBuilder}
            primaryButtonConfig={primaryButtonConfig}
            i18nLocale={i18nLocale}
          />
        }
        rightContent={
          <CollapsePathsSidebar
            state={state}
            commands={commands}
            i18nLocale={i18nLocale}
          />
        }
        rightContentInitialWidth={530}
        rightContentMinWidth={400}
      >
        <SimpleGraphContainerWithGreyBackground
          onClick={toggleGraphNodeSelection}
          onMouseOver={graphNodeOnHover}
        >
          <SimpleGraphView
            viewModel={{ graphNodes, graphEdges, graphGroups }}
            graphInterface={graphInterface.current}
            label={label}
            shouldFitToContentOnLayout={
              isFirstRender.current || !currentEditableRule
            }
          />
        </SimpleGraphContainerWithGreyBackground>
      </ResizablePageBody>
    </WithMetamodelLoader>
  );
};
